import React from 'react';
import { PageWrapper, LPTitle, LPText } from '../../pages/styles';

const PageNotFound = () => (
  <PageWrapper>
    <LPTitle>Sorry, this page isn&apos;t available.</LPTitle>
    <LPText>
      The link you followed may be broken, or the page may have been removed. Go back.
    </LPText>
  </PageWrapper>
);

export default PageNotFound;
